
import React from 'react'

import Tree from './Tree'
import SearchLink from 'cms_plugins/expert_search/js/components/SearchLink'


function Ding({pk, name, specification, gender, properties, edit_url}) {

    /* TODO: Eventuell passen bei den Eigenschaften nicht alle model-field SearchLinks, weil
        evtl. die verbose namen der Model-fields und das ad-hoc Zeug in
        metapher_flat/utils/search_widgets unterschiedlich sind!
        Mal überprüfen!
    */
    return (
        <div className="thing">
            <div className={"title"}>
                <div className={"name"}>
                    <SearchLink text={name} model={"Ding"} field={"Name"}/>
                </div>
                <div className={"gender"}>
                    <SearchLink text={gender} model={"Ding"} field={"Geschlecht"}/>
                </div>
                &nbsp;
                {edit_url && <a
                    className={"changelink"}
                    href={edit_url}
                    target={"_blank"}
                    title={"Ding bearbeiten"}
                />}
            </div>
            <ul className={"properties"}>
                {properties.map((p, i) => (
                    <li className={"property"} key={i}>
                        <span className={"category"}>{p.category}</span>
                        &nbsp;
                        <span className={"value"}>
                            <Tree items={p.value} model={"Ding"} field={p.category}/>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Ding;


// WEBPACK FOOTER //
// ./cms_plugins/zitat_display/js/components/Ding.js